export default {
  女装: "Pakaian wanita",
  男装: "Pria",
  手机和小工具: "Ponsel dan gadget",
  居家生活: "Kehidupan rumah",
  电脑及周边设备: "Komputer dan peralatan periferal",
  美容及个人护理: "Kecantikan dan perawatan pribadi",
  家用电器: "Peralatan Rumah Tangga",
  健康与保健: "Kesehatan dan kesejahteraan",
  食品和饮料: "Makanan dan minuman",
  玩具_儿童和婴儿: "Mainan, anak-anak dan bayi",
  童装时尚: "Busana anak-anak",
  视频游戏: "Video game",
  运动与户外: "Olahraga dan Luar Ruangan",
  爱好与书籍: "Hobi dan buku",
  相机和无人机: "Kamera dan drone",
  宠物食品及用品: "Makanan dan perlengkapan hewan peliharaan",
  女士包袋: "Tas wanita",
  男士包袋: "Tas pria",
  珠宝及配饰: "Perhiasan dan Aksesoris",
  手表: "Jam tangan",
  女鞋: "Sepatu Wanita",
  男装鞋: "Sepatu Pria",
  汽车: "Mobil",
  我附近的ShopeePay: "ShopeePay di dekat saya",
  餐饮_旅行和服务: "Katering, perjalanan dan layanan",
  旅行及行李: "Perjalanan dan bagasi",
  各种各样的: "Jenis yang berbeda",
  我是来买什么的: "Apa yang ingin saya beli di sini?",
  对不起_找不到_相关的商品:
    "Maaf, tidak ada produk yang terkait dengan [{0}] ditemukan",
  类别: "Kategori",
  产品: "Produk",
  店铺: "Toko",
  首页: "Halaman Depan",
  限时秒杀: "Penjualan kilat waktu terbatas",
  博客: "Blog",
  所有品牌: "Semua merek",
  所有类别: "Semua Kategori",
  我的购物车: "Keranjang belanjaan saya",
  发货信息: "Informasi pengiriman",
  交货信息: "Informasi pengiriman",
  付款: "Pembayaran",
  确认: "Mengonfirmasi",
  您的购物车是空的: "Keranjang belanja anda kosong",
  价格: "Harga",
  税: "Pajak",
  数量: "Kuantitas",
  总计: "Total",
  移除: "Menghapus",
  返回商店: "Kembali ke toko",
  继续发货: "Lanjutkan pengiriman",
  筛选: "Saring",
  价格范围: "Kisaran harga",
  排序方式: "Sortir dengan",
  最新: "Terkini",
  最旧: "Tertua",
  价格从低到高: "Harga dari rendah ke tinggi",
  价格从高到低: "Harga dari tinggi ke rendah",
  选择交货类型: "Pilih jenis pengiriman",
  送货上门: "Pengiriman",
  继续付款: "Terus membayar",
  任何其他信息: "Informasi lainnya",
  或者: "Atau",
  您的钱包余额: "Saldo dompet Anda",
  余额不足: "Saldo tidak mencukupi",
  支付: "Membayar",
  我同意: "Saya setuju",
  条款和条件: "Syarat dan Ketentuan",
  退货政策: "Kebijakan pengembalian",
  隐私政策: "Kebijakan pribadi",
  概括: "Menyamaratakan",
  项目: "Proyek",
  全部的: "Semua",
  小计: "Subtotal",
  总运费: "Total biaya pengiriman",
  有优惠码吗_在这里输入: "Apakah ada kode diskon? masuk ke sini",
  申请: "Menerapkan",
  编辑: "Sunting",
  删除: "Menghapus",
  添加新地址: "Tambahkan alamat baru",
  继续交货信息: "Lanjutkan informasi pengiriman",
  选择一个地址: "Pilih alamat",
  购买历史: "Riwayat pembelian",
  下载: "Unduh",
  已发送退款请求: "Permintaan pengembalian dana terkirim",
  对比: "Perbandingan",
  对话: "Dialog",
  我的钱包: "Dompet saya",
  工单: "Perintah kerja",
  管理个人资料: "Kelola profil",
  登出: "Keluar",
  重置对比列表: "Setel ulang daftar perbandingan",
  您的对比列表为空: "Daftar perbandingan Anda kosong",
  在您的购物车中: "Di keranjang belanja Anda",
  在您的愿望清单中: "Dalam daftar keinginan Anda",
  在您的预定列表中: "Pada daftar pemesanan Anda",
  下载您的产品: "Unduh produk Anda",
  选项: "Pilihan",
  什么都没找到: "Tidak ada yang ditemukan",
  特色产品: "Produk Pilihan",
  最畅销: "Penjualan terbaik",
  前_名: "{0} teratas",
  查看更多: "Lihat lebih banyak",
  查看所有类别: "Lihat semua kategori",
  十大品牌: "Sepuluh merek teratas",
  查看所有品牌: "Lihat semua merek",
  登录: "Gabung",
  手机号码: "Nomor telepon",
  密码: "Kata sandi",
  密码长度为6到16个字符: "Panjang kata sandi adalah 6 hingga 16 karakter",
  验证码: "Kode verifikasi",
  登录中: "Gabung",
  游客登录: "Login pengunjung",
  注册您的商店: "Daftarkan toko Anda",
  现在申请: "Lamar sekarang",
  成为商家: "Menjadi pedagang",
  现在注册: "Daftar sekarang",
  登录成功: "Berhasil mendarat",
  通知: "Memberitahu",
  未找到通知: "Pemberitahuan tidak ditemukan",
  评论: "Komentar",
  估计运输时间: "Perkiraan waktu pengiriman",
  天: "Langit",
  所售: "Terjual",
  给商家留言: "Tinggalkan pesan ke pedagang",
  规格: "Spesifikasi",
  库存: "Persediaan",
  总价: "Total harga",
  添加到购物车: "Masukkan ke keranjang",
  立即购买: "Beli sekarang",
  缺货: "Stok Habis",
  添加到愿望清单: "Tambahkan ke Daftar Keinginan b Indonesia",
  加入对比列表: "Tambahkan ke daftar perbandingan",
  退款: "Pengembalian dana",
  查看条款: "Lihat persyaratan",
  分享: "Membagikan",
  描述: "Menggambarkan",
  相关产品: "Produk-produk terkait",
  没有人问过商家: "Tidak ada yang bertanya kepada para pedagang",
  该产品暂无评论: "Belum ada ulasan untuk produk ini",
  客户评论: "Ulasan pelanggan",
  访问商店: "Mengunjungi toko",
  畅销产品: "Penjualan terbaik",
  日期: "Tanggal",
  订单编号: "Jumlah order",
  总额: "Jumlah bulat",
  状态: "Negara",
  愿望清单: "Daftar Favorit",
  还没有添加任何东西: "Belum ada yang ditambahkan",
  注册: "Daftar",
  邀请码: "Kode undangan",
  请输入邀请码: "Silakan masukkan kode undangan",
  用户名: "Nama pengguna",
  请输入用户名: "Silakan masukkan nama pengguna",
  用户名长度为6_14个字符: "Panjang nama pengguna adalah 6-14 karakter",
  昵称: "Nama panggilan",
  请输入手机号码: "Silakan masukkan nomor telepon",
  手机号码格式错误: "Format nomor telepon salah",
  密码长度为6_16个字符: "Panjang kata sandi adalah 6-16 karakter",
  确认密码: "Konfirmasi kata sandi",
  请输入确认密码: "Silakan masukkan kata sandi konfirmasi",
  提款密码: "Kata sandi penarikan",
  请输入提款密码: "Silakan masukkan kata sandi penarikan",
  提款密码长度为4_16个字符: "Panjang kata sandi penarikan adalah 4-16 karakter",
  请输入验证码: "Silakan masukkan kode verifikasi",
  在_s后发送: "Dikirim setelah {0}dtk",
  发送验证码: "Kirim kode verifikasi",
  注册即表示您同意我们的条款和条件:
    "Dengan mendaftar, Anda menyetujui syarat dan ketentuan kami.",
  创建账号: "Buat Akun",
  验证码发送成功: "Kode verifikasi berhasil dikirim",
  确认密码不一致: "Konfirmasikan bahwa kata sandi tidak konsisten",
  提款密码必须为数字: "Kata sandi penarikan harus berupa angka",
  注册成功: "Registrasi berhasil",
  购物车: "Keranjang",
  账户: "Akun",
  我的账户: "Akun saya",
  已经有一个账户: "Sudah memiliki akun",
  新地址: "Alamat baru",
  编辑地址: "Sunting alamat",
  保存: "Menyimpan",
  是否默认: "Apakah ini defaultnya",
  具体地址: "Alamat khusus",
  请输入具体地址: "Silakan masukkan alamat spesifik",
  地区: "Daerah",
  请输入地区: "Silakan masukkan wilayah",
  城市: "Kota",
  请输入城市: "Silakan masukkan kota",
  省份: "Propinsi",
  请输入省份: "Silakan masukkan Provinsi",
  邮政编码: "Kode Pos",
  请输入邮政编码: "Silakan masukkan kode pos",
  电话号码: "Nomor telepon",
  请输入电话号码: "Masukkan nomor telepon anda",
  收货人: "Penerima",
  请输入收货人: "Silakan masukkan penerima barang",
  保存成功: "Berhasil disimpan",
  最畅销的商家: "Merchant Terlaris",
  查看所有的商家: "Lihat semua bisnis",
  支持政策: "Kebijakan dukungan",
  您的电子邮件地址: "Alamat email anda",
  订阅: "Berlangganan",
  联系方式: "Kontak informasi",
  地址: "Alamat",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, AS",
  快速链接: "TENTANG KAMI",
  商家政策: "Kebijakan pedagang",
  submit: "Kirim",
  提款银行卡: "Penarikan kartu bank",
  我的面板: "Panel saya",
  提示: "Petunjuk",
  确定登出吗: "Apakah Anda yakin ingin logout?",
  确定: "Tentu",
  取消: "Membatalkan",
  项目添加到您的购物车: "Tambahkan item ke keranjang belanja Anda",
  经常一起购买: "Sering membeli bersama-sama",
  返回购物: "Kembali berbelanja",
  进行结算: "Lanjutkan ke pembayaran",
  帮助热线: "Saluran bantuan",
  查看所有通知: "Lihat semua notifikasi",
  请输入密码: "Silakan masukkan kata sandi",
  前往充值: "Pergi untuk mengisi ulang",
  购物车物品: "Item keranjang belanja",
  查看购物车: "Periksa keranjang belanja",
  钱包余额: "Saldo dompet",
  充值钱包: "Isi ulang dompet",
  钱包充值_线下_: "Isi ulang dompet (offline)",
  申请提款: "Ajukan permohonan penarikan",
  钱包收支明细: "Detail Pendapatan dan Pengeluaran Dompet",
  批准: "Menyetujui",
  提现历史记录: "Riwayat penarikan",
  类型: "Jenis",
  信息: "Informasi",
  付款方式: "Cara Pembayaran",
  请选择付款方式: "Silakan pilih metode pembayaran",
  Bill_Type_RECHARGE_BACK: "Isi ulang bagian belakang",
  Bill_Type_RECHARGE_ONLINE: "Isi ulang daring",
  Bill_Type_RECHARGE_REGISTER: "Daftar gratis",
  Bill_Type_RECHARGE_JACKPOT: "Bonus isi ulang",
  Bill_Type_RECHARGE_PRESENT: "Isi ulang hadiah",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Transfer komisi",
  Bill_Type_RECHARGE_TG_COMMISSION: "Isi ulang komisi promosi",
  Bill_Type_REGISTER_TG_COMMISSION: "Komisi promosi pendaftaran",
  Bill_Type_WITHDRAW: "Menarik",
  Bill_Type_WITHDRAW_REJECT: "Penarikan ditolak",
  Bill_Type_DEDUCT_HANDLE: "Pengurangan manual",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Koreksi isi ulang",
  Bill_Type_MINING_PROFIT: "Pendapatan pertambangan",
  Bill_Type_MINING_PROFIT_COMMISSION: "Komisi promosi pendapatan pertambangan",
  Bill_Type_VIP_UPGRADE: "Tingkatkan VIP",
  Bill_Type_FINANCE_BUY: "Beli produk keuangan",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Pengembalian saldo keuangan",
  Bill_Type_FINANCE_FEE: "Biaya pengelolaan keuangan",
  Bill_Type_FINANCE_PROFIT: "Pendapatan pengelolaan keuangan",
  Bill_Type_FINANCE_BUY_COMMISSION: "Komisi untuk pembelian produk keuangan",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "Komisi pendapatan produk keuangan",
  Bill_Type_WHEEL_DRAW: "Lotere roda besar",
  Bill_Type_BUY: "Membeli barang",
  Bill_Type_PAY_SHOP: "Bayar untuk pengiriman",
  Bill_Type_BUY_COMMISSION: "Komisi untuk barang yang dibeli",
  Bill_Type_DEPOSIT: "Bayar setoran",
  Bill_Type_STORE_BUY: "Membeli barang",
  Bill_Type_STORE_BUY_REFUND: "Pengembalian dana pembelian produk",
  Bill_Type: "Jenis perubahan akun",
  Before_Money: "Jumlah sebelumnya",
  Deal_Money: "Jumlah perubahan akun",
  After_Money: "Jumlah setelahnya",
  Bill_Time: "Waktu pergantian akun",
  No_More_Data: "Tidak ada data lagi",
  Apply_Money: "Jumlah Aplikasi",
  Apply_Time: "Waktu aplikasi",
  Withdraw_Info: "Biaya penanganan: {fee}, kedatangan: {money}",
  提款订单状态_CHECKING: "Tinjauan tertunda",
  提款订单状态_TRANSFERRING: "Mentransfer",
  提款订单状态_PASS: "Dikonfirmasi",
  提款订单状态_REJECT: "Dibubarkan",
  暂无可用充值方式: "Belum ada metode isi ulang yang tersedia",
  钱包收款码: "Kode pembayaran dompet",
  钱包地址: "Alamat dompet",
  金额限制: "Batasan jumlah",
  复制: "Menyalin",
  付款凭证: "Voucher pembayaran",
  收款银行: "Bank Penerima",
  收款人: "Penerima pembayaran",
  收款账号: "Nomor rekening pembayaran",
  付款银行: "Bank pembayaran",
  付款人: "Pembayar",
  付款账号: "Akun pembayaran",
  请输入付款银行: "Silakan masukkan bank pembayaran",
  请输入付款人: "Silakan masukkan pembayar",
  请输入付款账号: "Silakan masukkan nomor rekening pembayaran",
  请上传付款凭证: "Silakan unggah voucher pembayaran",
  充值金额: "Jumlah isi ulang",
  请输入充值金额: "Silakan masukkan jumlah isi ulang",
  submitting: "Mengirimkan...",
  Confirm: "Kirim",
  Commit_Success: "Berhasil dikirimkan",
  balanceType_BALANCE: "Keseimbangan",
  balanceType_COMMISSION: "Komisi",
  Balance: "Saldo rekening",
  Wash_Money: "Tambahkan mosaik",
  请选择银行账户: "Silakan pilih rekening bank",
  卡号类型: "Jenis nomor kartu",
  提现金额: "Jumlah penarikan",
  提款金额: "Jumlah penarikan",
  不能为空: "Tidak boleh kosong",
  金额不正确: "Jumlahnya salah",
  please_input_withdraw_password: "Silakan masukkan kata sandi penarikan",
  withdraw_password_format_error: "Kata sandi penarikan harus 4-16 karakter",
  Fee: "Biaya penanganan",
  实际到账: "Kedatangan sebenarnya",
  交易币种: "Transaksi mata uang",
  原始密码: "Kata sandi asli",
  confirm_password_error: "Kata sandi yang dimasukkan dua kali salah",
  save_success: "Berhasil disimpan",
  please_input: "Silakan masuk",
  old_password: "Password lama",
  new_password: "Kata sandi baru",
  please_input_confirm_password: "Harap konfirmasi kata sandi lagi",
  没有找到符合条件的商品: "Tidak ditemukan produk yang cocok",
  Search: "Mencari",
  全部: "Semua",
  EnumGoodsOrderState_USER_PAY: "Menunggu pengiriman",
  EnumGoodsOrderState_SHOP_PAY: "Menyampaikan",
  EnumGoodsOrderState_SUCCESS: "Menyelesaikan",
  EnumGoodsOrderState_CANCEL: "Dibatalkan",
  EnumGoodsOrderState_REFUND_SUCCESS: "Dikembalikan",
  订单号: "Jumlah order",
  用户名称: "Nama belakang",
  收益: "Penghasilan",
  支付时间: "Waktu pembayaran",
  配送时间: "Waktu Pengiriman",
  完成时间: "Waktu yang lengkap",
  发货: "Mengirimkan",
  全选: "Pilih Semua",
  物品已添加到愿望清单: "Item ditambahkan ke daftar keinginan",
  物品已添加到比较列表: "Item ditambahkan ke daftar perbandingan",
  购买成功提示: "Selamat, pembelian Anda berhasil",
  订单列表: "Daftar Pesanan",
  商品名: "Nama Produk",
  图片: "Gambar",
  没有品牌: "Tidak bermerek",
  基本信息: "Informasi dasar",
  Account_Name: "Nama pembuka rekening",
  Bank_Account: "Akun bank",
  Bank_Phone: "Cadangan nomor ponsel",
  IFSC: "Akun IFSC",
  UPI: "Akun UPI",
  PIX: "Akun PIX",
  CPF: "Akun CPF",
  GCASH: "Akun GCASH",
  POWWI: "Akun POWWI",
  身份证号: "Nomor ID",
  Edit: "Merevisi",
  Delete: "Menghapus",
  Add: "Baru",
  Forget_Withdraw_Password: "Lupa kata sandi penarikan",
  Bank_Card_Info: "Informasi kartu bank",
  收款人地址: "Alamat Penerima Pembayaran",
  SWIFT: "CEPAT",
  Bank_Branch: "Nama cabang",
  分行代码: "Kode cabang",
  银行地址: "Alamat bank",
  Email: "Surel",
  银行卡长度必须超过: "Panjang kartu bank harus melebihi {length}",
  银行卡格式不正确: "Format kartu bank salah",
  Do_you_confirm_delete: "Konfirmasi penghapusan?",
  Please_Login_First: "Silahkan masuk terlebih dahulu",
  Bank_Name: "Nama Bank",
  Please_add_bank_first:
    "Anda belum mengikat kartu bank Anda, harap tambahkan terlebih dahulu",
  withdrawType: "Jenis penarikan",
  withdraw_money_limit:
    "Jumlah penarikan harus lebih besar dari 0 dan kurang dari atau sama dengan {saldo}",
  withdraw_times_limit:
    "Anda telah menarik {todayWithdrawNum} kali hari ini, dan biaya penanganan sebesar {withdrawFee}% akan dikenakan setelah {limitTimes} kali. Apakah Anda yakin untuk mundur?",
  Copy_Success: "Berhasil disalin",
  商店首页: "Halaman beranda toko",
  所有产品: "Semua produk",
  新到货产品: "Produk baru tiba",
  所有商家: "Semua pedagang",
  请上传: "Silakan unggah",
  请输入: "Silakan masuk",
  忘记密码: "Lupa kata sandi",
  记得我: "Ingatkan saya",
  共_件: "Jumlahnya {0} item",
  取消订单: "Batalkan pesanan",
  申请退款: "Minta pengembalian dana",
  未知商家: "Pedagang tak dikenal",
  到账: "Kuitansi",
  提款订单状态: "Status pesanan penarikan",
  前_名类别: "{0} kategori teratas",
  取消订单原因_不想要了: "Tidak menginginkannya lagi",
  取消订单原因_商品错选_多选: "Pemilihan produk salah/pilihan ganda",
  取消订单原因_商品无货: "Produk kehabisan stok",
  取消订单原因_地址信息填写错误: "Informasi alamat yang diisi salah",
  取消订单原因_商品降价: "Penurunan harga produk",
  取消订单原因_价格高于其他平台: "Harganya lebih tinggi dari platform lain",
  取消订单原因_没用_少用_错用优惠:
    "Tidak ada guna/kurang guna/penyalahgunaan diskon",
  退款原因_拍错_多拍_不喜欢: "Tembakan salah / tembakan ekstra / tidak suka",
  退款原因_商品成分描述不符: "Deskripsi bahan produk tidak cocok",
  退款原因_与商家协商一致退款:
    "Pengembalian dana sesuai kesepakatan dengan pedagang",
  退款原因_生产日期_保质期与商品描述不符:
    "Tanggal produksi/umur simpan tidak sesuai dengan deskripsi produk",
  退款原因_图片_产地_批号_规格等描述不符:
    "Gambar/asal asal/nomor batch/spesifikasi dan deskripsi lainnya tidak sesuai",
  退款原因_质量问题: "Masalah kualitas",
  退款原因_商品变质_发霉_有异物: "Produk rusak/berjamur/ada benda asing",
  退款原因_少件_含缺少配件_: "Beberapa bagian (termasuk aksesori yang hilang)",
  退款原因_收到商品时有破损_污渍_变形:
    "Barang rusak/bernoda/cacat saat diterima.",
  退款原因_假冒品牌: "Merek palsu",
  退款原因_发票问题: "Masalah faktur",
  退款原因_商家发错货: "Pedagang itu mengirim barang yang salah",
  退款原因_预约不到_商家不给退换:
    "Tidak dapat membuat janji/pedagang tidak memberikan pengembalian atau penukaran",
  退款失败: "Pengembalian dana gagal",
  退款处理中: "Pengembalian dana sedang berlangsung",
  默认: "Bawaan",
  产品查询: "Pencarian Produk",
  商店LOGO: "LOGO toko",
  推广码: "Kode promosi",
  查看所有: "Lihat semua",
  确认收货成功: "Konfirmasi penerimaan barang berhasil",
  物流公司: "Perusahaan logistik",
  物流单号: "Nomor pengiriman",
  发货时间: "Waktu pengiriman",
  请先选择商品规格: "Silakan pilih spesifikasi produk terlebih dahulu",
  个人信息: "Informasi pribadi",
  您的用户名: "Nama pengguna Anda",
  你的名字: "Namamu",
  登录名: "Nama belakang",
  你的邮件: "Email mu",
  你的密码: "Kata sandi Anda",
  重复输入密码: "Masukkan kata kunci kembali",
  店铺名称: "Nama Toko",
  证书类型: "Tipe Sertifikat",
  身份证: "KTP",
  护照: "Paspor",
  驾驶执照: "Surat izin Mengemudi",
  社会保障卡: "Kartu jaminan sosial",
  证书正面: "Sertifikat depan",
  证书反面: "Sisi sebaliknya sertifikat",
  确认收货: "Konfirmasi penerimaan barang",
  请选择取消订单的原因必选: "Silakan pilih alasan pembatalan pesanan (wajib):",
  请选择申请退款的原因必选:
    "Silakan pilih alasan meminta pengembalian dana (wajib):",
  留言: "Pesan",
  请输入留言: "Silakan masukkan pesan",
  没有帐户: "Tidak ada akun",
  钱包充值: "Isi ulang dompet",
  输入您的文字: "Masukkan teks Anda",
  商家登录: "Login pedagang",
  有关此产品的任何查询: "Setiap pertanyaan tentang produk ini",
  产品名称: "Nama Produk",
  你的问题: "Masalahmu",
  白银店铺: "Toko perak",
  铂金店铺: "Toko platina",
  钻石店铺: "Toko berlian",
  照片: "Foto",
  已退货: "Kembali",
  邮寄状态: "Status pengiriman",
  订单摘要: "Ringkasan pesanan",
  收件地址: "Alamat penerima",
  订购日期: "Tanggal pemesanan",
  订单状态: "Status pemesanan",
  总订单金额: "Jumlah total pesanan",
  邮寄方式: "Metode pengiriman surat",
  附加信息: "Informasi tambahan",
  订单详细信息: "Detail pesanan",
  交货类型: "Jenis pengiriman",
  进行评论: "Berikan komentar",
  已评论: "Berkomentar",
  订单金额: "Jumlah pesanan",
  优惠券: "Kupon",
  统一运费: "Biaya pengiriman tetap",
  送货地址: "Alamat pengiriman",
  评分: "Skor",
  你的意见: "Pendapat Anda",
  匿名: "Anonim",
  现金: "Uang tunai",
  详情: "Detail",
  收货地址: "Alamat pengiriman",
  暂时没有对话: "Belum ada percakapan",
  你: "Anda",
  输入您的回复: "Masukkan balasan Anda",
  删除成功: "Berhasil dihapus",
  品牌: "Merek",
  已缴纳的保证金: "Uang jaminan telah dibayarkan",
  黄金店铺: "Toko emas",
  没有更多数据: "Tidak ada data lagi",
  站内信: "Pesan situs",
  系统通知: "Pemberitahuan sistem",
  邮箱: "Surat",
  手机号: "Nomor telepon",
  你的手机号: "Nomor telepon Anda",
  营业执照: "Lisensi bisnis",
  你的邮箱: "Kotak surat Anda",
  搜索结果: "Hasil Pencarian",
  系统公告: "Pemberitahuan sistem",
  客服: "Pelayanan pelanggan",
  消息已撤回: "Pesan telah ditarik",
  物流详情: "Detail logistik",
  充值: "Isi ulang",
  提现: "Menarik",
  信用分: "Nilai kredit",
  余额: "Keseimbangan",
  佣金: "Komisi",
  继续购物: "Lanjutkan Belanja",
  订单结算: "Penyelesaian pesanan",
  加入对比: "Tambahkan ke perbandingan",
  佣金余额: "Saldo komisi",
  刷新: "Menyegarkan",
  刷新成功: "Penyegaran berhasil",
  官网: "Situs web resmi",
  税号: "Nomor Pokok Wajib Pajak",
  订单: "Memesan",
  合计: "Total",
  系统安全: "Keamanan sistem",
  Recharge_Money_Limit: "Jumlah isi ulang harus antara {min} dan {max}",
  限时优惠: "Penawaran waktu terbatas",
  高价回收: "Daur ulang dengan harga tinggi",
  姓名: "Nama",
  商品订单号: "Nomor pesanan produk",
  商品在线回收: "Daur ulang produk secara online",
  提交: "kirim",
  回收记录: "Catatan daur ulang",
  回收状态: "Status daur ulang",
  回收价格: "harga daur ulang",
  纳税码: "kode pajak",
  买家登录: "Masuk",
  买家注册: "daftar",
  language: "印尼语",
  助力提示:
    "Membantu pedagang dapat meningkatkan paparan platform ke toko mereka, dan semakin tinggi jumlah hari kumulatif, semakin tinggi paparannya.",
  已累计助力: "Dibantu secara kumulatif",
  今日已助力: "Hari ini telah membantu",
  立即助力: "Membantu segera",
  商家助力: "Bantuan pedagang",
  证件号码: "Nomor ID",
  证书号码: "Nomor Sertifikat",
  男鞋: "Sepatu pria",
  游戏玩具: "Mainan game",
  使用条款: "Ketentuan Penggunaan",
  商家: "Pedagang",
  已助力: "Telah membantu",
  被助力: "Dibantu",
  用户: "pengguna",
  助力记录: "Catatan Bantuan",
  消息类型: "Jenis pesan",
  消息内容: "Konten pesan",
  链接: "Link",
  文本: "teks",
  清空: "Jernih",
  评论成功: "Komentar berhasil",
  扫描二维码: "Pindai kode QR",
  转入: "transfer masuk",
  收款: "Koleksi",
  任务下单中心: "Pusat urutan tugas",
  记录: "catatan",
  任务倒计时: "Hitung mundur tugas",
  倒计时后自动放弃: "Secara otomatis menyerah setelah hitungan mundur",
  业务码: "Kode bisnis",
  选择商品分类: "Pilih kategori produk",
  可多选: "Beberapa pilihan mungkin",
  加载分类中: "Memuat kategori",
  暂无分类: "Belum ada klasifikasi",
  产品类别: "Kategori Produk",
  账户余额: "Saldo akun",
  立即结算: "Penyelesaian segera",
  任务已自动放弃: "Tugas tersebut secara otomatis ditinggalkan",
  商品分类: "Klasifikasi produk",
  订单详情: "Detail pesanan",
  预计收益: "Perkiraan pendapatan",
  预计佣金收益: "Perkiraan pendapatan komisi",
  收益率: "Hasil",
  扣款账户: "Rekening debet",
  确认结算: "Konfirmasikan penyelesaian",
  未选择: "Tidak dipilih",
  请选择商品分类: "Silakan pilih kategori produk",
  下单成功: "Pesanan berhasil dilakukan",
  下单失败: "Pesanan gagal",
  请重试: "Silakan coba lagi",
  订单记录: "Catatan pesanan",
  没有更多了: "tidak lebih",
  业务号: "Nomor bisnis",
  商品类型: "Jenis produk",
  佣金收益: "pendapatan komisi",
  待结算: "Penyelesaian tertunda",
  已结算: "Menetap",
  已取消: "Dibatalkan",
  加载失败: "Gagal memuat",
  倒计时: "Hitung mundur",
  随机商品: "item acak",
  为: "untuk",
  商户助力可提升商品曝光度:
    "Bantuan pedagang dapat meningkatkan eksposur produk",
  累计助力越高推荐权重越高:
    "Semakin tinggi akumulasi bantuan maka semakin tinggi pula bobot rekomendasinya.",
  实时助力动态: "Dinamika bantuan real-time",
  助力奖励: "Tingkatkan imbalan",
  随机奖励金额已生成: "Jumlah hadiah acak telah dihasilkan",
  开心收下: "Senang menerimanya",
  助力已结束: "Bantuan telah berakhir",
  助力成功: "Membantu kesuksesan",
  成功: "sukses",
  进行中: "Sedang berlangsung",
  等待: "tunggu",
  助力失败: "Bantuan gagal",
  任務: "Tugas",
  下单失败_请稍后重试: "Pesanan gagal, silakan coba lagi nanti",
  任务: "Tugas"
};
